import { useTranslation } from "react-i18next";
import { Clipboard } from "lucide-react";
const TONES = {
  slate:   "bg-slate-50 border-slate-200 text-slate-700",
  blue:    "bg-blue-50 border-blue-200 text-blue-700",
  emerald: "bg-emerald-50 border-emerald-200 text-emerald-700",
  violet:  "bg-violet-50 border-violet-200 text-violet-700",
};

// بطاقة معلومات التسليم — المصدر / المسلّم / المستلم / تاريخ ووقت الإرسال.
export const MyBillSignInfo = ({ bill, cashbox, sentBy, sentAt }) => {
  const { t } = useTranslation();
  const boxTxt = cashbox ? `${cashbox.kind === "bank" ? "🏦" : "💰"} ${cashbox.name}` : "—";
  const when = sentAt
    ? new Date(sentAt).toLocaleString("en-GB", { dateStyle: "short", timeStyle: "short" })
    : "—";
  const Item = ({ label, value, tone = "slate" }) => (
    <div className={`rounded-xl border p-3 ${TONES[tone]}`}>
      <p className="text-[10px] font-bold uppercase opacity-80">{label}</p>
      <p className="mt-1 text-sm font-black leading-snug" dir="ltr" style={{ textAlign: "start" }}>{value || "—"}</p>
    </div>
  );
  return (
    <div className="rounded-2xl border-2 border-slate-200 bg-white p-4">
      <p className="mb-3 flex items-center gap-2 text-sm font-black text-slate-800">
        <Clipboard className="h-4 w-4" /> {t("acct.bills.mysign.deliveryInfo")}
      </p>
      <div className="grid grid-cols-2 gap-2">
        <Item label={t("acct.bills.mysign.source")}   value={boxTxt} />
        <Item label={t("acct.bills.mysign.sender")}   value={sentBy || "—"} tone="blue" />
        <Item label={t("acct.bills.mysign.receiver")} value={bill.receiver_name} tone="emerald" />
        <Item label={t("acct.bills.mysign.sentAt")}   value={when} tone="violet" />
      </div>
    </div>
  );
};
